export enum CHAT_TYPES {
  VOYAGER = 'voyager',
  QUARTERMASTER = 'quartermaster',
  CARTOGRAPHER = 'cartographer',
  SCRIBE = 'scribe',
}

export default CHAT_TYPES;

